import React, { createContext, useState, useContext, useEffect } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // ✅ Başlangıçta localStorage'dan yükle
  useEffect(() => {
    try {
      const stored = localStorage.getItem('aktifKullanici');
      if (stored) {
        const parsed = JSON.parse(stored);
        setUser(parsed);
      }
    } catch (error) {
      console.error('Auth yükleme hatası:', error);
      localStorage.removeItem('aktifKullanici');
      localStorage.removeItem('authToken'); // ✅ Token da temizle
    } finally {
      setLoading(false);
    }
  }, []);

  // ✅ Login — Backend API'ye istek atar
  const login = async (email, password) => {
    try {
      const response = await fetch('/api/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.hata || 'Giriş başarısız');
      }

      // Backend'den dönen token ve user bilgisi
      const { token, user: userData } = data;

      // Token'ı localStorage'a kaydet
      localStorage.setItem('authToken', token);
      
      // User bilgisini localStorage'a kaydet
      localStorage.setItem('aktifKullanici', JSON.stringify(userData));
      
      // State'i güncelle
      setUser(userData);

      return { success: true, user: userData };
    } catch (error) {
      console.error('Login hatası:', error);
      throw error;
    }
  };

  // ✅ Logout — hem state hem localStorage temizler
  const logout = () => {
    setUser(null);
    localStorage.removeItem('aktifKullanici');
    localStorage.removeItem('authToken'); // ✅ Token da temizle
  };

  // ✅ Token'ı al (API istekleri için)
  const getToken = () => {
    return localStorage.getItem('authToken');
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, getToken }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);